import React from 'react';

const Page404 = () => {
    return (
        <div className={"d-flex flex-column justify-content align-items-center"}>
            <h1>آدرس صفحه مورد نظر یافت نشد...</h1>
            <img src={"./../assets/media/illustrations/unitedpalms-1/18.png"} width={"100%"}/>
        </div>
    );
};

export default Page404;